import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { busesAPI } from "components/Apis/Buses";


export const fetchBus = createAsyncThunk(
    'logistics/fetchBus',
    async (busId, { rejectWithValue }) => {
        try {
            const response = await busesAPI.getSpecificBusDetailed(busId);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

const specificBusSlice = createSlice({
    name: 'specificBus',
    initialState: {
        bus: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchBus.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchBus.fulfilled, (state, action) => {
                state.loading = false;
                state.bus = action.payload; // Store the fetched bus
            })
            .addCase(fetchBus.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload; // Store error message
            });
    },
});

export default specificBusSlice.reducer;